import React from "react";
import { useTranslation } from "react-i18next";
import type { TransformedOrderItem } from "../types/orderApiTypes";
// No longer need formatMinorUnitString
import type { ThemeVariables } from "../../../types";

interface OrderItemRowProps {
  item: TransformedOrderItem;
}

const OrderItemRow: React.FC<OrderItemRowProps> = ({ item }) => {
  const { t } = useTranslation();

  const currencySymbol =
    (window.themeVariables as ThemeVariables | undefined)?.currencySymbol ||
    "₺";

  // The formatting is now done in the API layer, so we can directly use the property.
  const formattedLineSubtotal = item.formattedLineSubtotal;

  return (
    <tr className="order-item-row">
      <td className="item-thumbnail">
        <a href={item.permalink}>
          <img
            src={item.images?.[0]?.thumbnail || ""}
            alt={item.name}
            width="50"
            height="50"
          />
        </a>
      </td>
      <td className="item-name" data-label={t("cart.item.product", "Product")}>
        <a href={item.permalink}>{item.name}</a>
        {item.variation && item.variation.length > 0 && (
          <div className="item-variation-attributes">
            {item.variation.map((v, index) => {
              const attributeDisplay =
                typeof v.attribute === "string" ? v.attribute : "";
              const valueDisplay = typeof v.value === "string" ? v.value : "";

              if (!attributeDisplay || !valueDisplay) {
                return null;
              }

              return (
                <div
                  key={`${attributeDisplay}-${index}`}
                  className="variation-line"
                >
                  <span className="variation-attribute-label">
                    {attributeDisplay}:
                  </span>
                  <span className="variation-attribute-value">
                    {valueDisplay}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </td>
      <td
        className="item-quantity"
        data-label={t("cart.item.quantity", "Quantity")}
      >
        {item.quantity}
      </td>
      <td className="item-total" data-label={t("order.item.total", "Total")}>
        {formattedLineSubtotal}
        {currencySymbol}
      </td>
    </tr>
  );
};

export default OrderItemRow;
